import React from 'react';
import string from 'prop-types';

const GreenTick = ({ fill }) => {
    return (
        <svg
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.50195 16.2967C6.94258 15.7315 7.37811 15.1713 7.81534 14.6144C10.9559 10.6029 14.3585 6.82649 18.4041 3.66696C20.0459 2.38481 21.8322 1.27939 23.5505 0.0906047C23.7717 -0.0627868 23.9078 -0.0211043 23.9996 0.217319C23.9129 0.269006 23.8091 0.302352 23.7445 0.372378C21.7318 2.54487 19.6784 4.68568 17.7219 6.90652C15.187 9.78428 12.9855 12.9055 11.0597 16.205C10.0083 18.0057 9.04367 19.8564 8.03821 21.6821C7.81534 22.0873 7.66903 22.1006 7.3577 21.7455C4.95208 19.0061 2.54817 16.2651 0.139153 13.529C0.0030501 13.3756 -0.0650012 13.2539 0.0847117 13.0622C0.248035 12.8538 0.389241 12.9471 0.555967 13.0388C2.42738 14.0709 4.29879 15.1013 6.1719 16.1317C6.26888 16.185 6.37095 16.2301 6.50365 16.2967H6.50195Z"
                fill={fill}
            />
        </svg>
    );
};

GreenTick.propTypes = {
    fill: string
};

GreenTick.defaultProps = {
    fill: '#1E9F60'
};

export default GreenTick;
